import type { ProfileConfig } from '@/types/edit/ProfileConfig.ts';
import type { StepConfig } from '@/types/edit/StepConfig.ts';
import type { PromptConfig } from '@/types/edit/PromptConfig.ts';
import { ProfileConfigService } from '@/services/config/ProfileConfigService.ts';
import { StepConfigService } from '@/services/config/StepConfigService.ts';
import { PromptConfigService } from '@/services/config/PromptConfigService.ts';

export const getConfigData = (
    profileConfigId: ProfileConfig['id'],
    stepConfigId: StepConfig['id'] | undefined,
): {
    profileConfig: ProfileConfig | undefined;
    stepConfig: StepConfig | undefined;
    promptConfigs: PromptConfig[];
} => {
    const profileConfig = ProfileConfigService.getAllProfileConfigs()[profileConfigId];
    if (!profileConfig) {
        return {
            profileConfig: undefined,
            stepConfig: undefined,
            promptConfigs: [],
        };
    }

    const steps = Object.values(StepConfigService.getAllStepConfigs()).filter((s) =>
        profileConfig.stepIds.includes(s.id),
    );
    let stepConfig: StepConfig | undefined;

    if (!stepConfigId) {
        stepConfig = steps.find((s) => s.order === 0);
    } else {
        stepConfig = steps.find((s) => s.id === stepConfigId);
    }

    let promptConfigs: PromptConfig[] = [];
    if (stepConfig) {
        promptConfigs = Object.values(PromptConfigService.getAllPromptConfigs()).filter(
            (prompt) =>
                profileConfig.promptIds.includes(prompt.id) && prompt.stepId === stepConfig.id,
        );
    }

    return {
        profileConfig,
        stepConfig,
        promptConfigs,
    };
};
